/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import Dispatch from "nexia_mobile/flux_like/dispatch";

import type { ThermostatFeature } from "./types";

export default function Thermostat(feature: ThermostatFeature) {
  const setHeatAction = feature.actions.set_heat_setpoint;
  const setCoolAction = feature.actions.set_cool_setpoint;
  const setSetpointsAction = feature.actions.set_setpoints;

  const isCelsius = feature.setpoint_increment === 0.5;

  this.setSetpoints = (setpoints) => {
    if (!setpoints.heat && !setpoints.cool) {
      return Promise.reject(
        new Error(
          "Attempted to set setpoints, but neither a heat setpoint nor a cool setpoint was provided"
        )
      );
    }

    const action = setSetpointsAction || setHeatAction || setCoolAction;
    if (action == null) {
      return Promise.reject(
        new Error(
          "Cannot set setpoints on a thermostat with neither a heat action nor a cool action"
        )
      );
    }

    const stubResponse = {};
    if (setpoints.heat) {
      stubResponse.setpoint_heat = setpoints.heat;
    }
    if (setpoints.cool) {
      stubResponse.setpoint_cool = setpoints.cool;
    }
    // Some endpoints (xxls, possibly more) don't actually update right away.
    // Set the setpoints where we expect them to be, then hopefully they'll
    // be updated by the next poll cycle.
    this.set(stubResponse);

    const heatBefore = this.get("setpoint_heat");
    const coolBefore = this.get("setpoint_cool");

    return this.executeDeviceAction(action, setpoints, {
      updateModelWithResponse: false, // some endpoints don't return the right data :-(
    }).then(() => {
      if (stubResponse.setpoint_heat !== heatBefore) {
        Dispatch(
          "DEMO_MODE_EVENT",
          this,
          `Heat setpoint set to ${setpoints.heat}\u00B0${isCelsius ? "C" : "F"}`
        );
      }

      if (stubResponse.setpoint_cool !== coolBefore) {
        Dispatch(
          "DEMO_MODE_EVENT",
          this,
          `Cool setpoint set to ${setpoints.cool}\u00B0${isCelsius ? "C" : "F"}`
        );
      }
    });
  };

  const result = {
    status: feature.status,
    status_icon: feature.status_icon,
    temperature: feature.temperature,
    temperature_scale: isCelsius ? "c" : "f",
    setpoint_delta: feature.setpoint_delta,
    setpoint_increment: feature.setpoint_increment,
    alert_temperature_low: feature.alert_temperature_low,
    alert_temperature_high: feature.alert_temperature_high,
    setpoint_heat: feature.setpoint_heat,
    setpoint_cool: feature.setpoint_cool,
    setpoint_heat_min: feature.setpoint_heat_min || (isCelsius ? 13 : 55),
    setpoint_heat_max: feature.setpoint_heat_max || (isCelsius ? 32 : 90),
    setpoint_cool_min: feature.setpoint_cool_min || (isCelsius ? 16 : 60),
    setpoint_cool_max: feature.setpoint_cool_max || (isCelsius ? 37 : 99),
  };

  return result;
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/thermostat.js